import cookie from "./cookie";
import queryString from "query-string";

import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";

let visitorId = "",
  requestId = "";
const fpPromise = FingerprintJS.load({
  apiKey: "AiLUeNvTQl9BDN0ixVFb",
  // region: "ap-south-1",
});
fpPromise
  .then((fp) => fp.get())
  .then((result) => {
    visitorId = result.visitorId;
    requestId = result.requestId;
  });

function checkStatus(response, timer) {
  clearTimeout(timer);
  timer = null;
  if (response.status >= 200 && response.status < 502) {
    return response;
  } else {
    return Promise.reject(response.statusText);
  }
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
async function request(_url, options) {
  if (options.needRequestId) {
    const res = await new Promise((resolve, reject) => {
      fpPromise
        .then((fp) => fp.get())
        .then((result) => {
          visitorId = result.visitorId;
          requestId = result.requestId;
          resolve(result);
        });
    });
  }

  let url = _url;
  const fheaders = new Headers();
  fheaders.append("X-Requested-With", "XMLHttpRequest");
  if (cookie.read("lan")) {
    fheaders.append("exchange-language", cookie.read("lan"));
  }
  fheaders.append("exchange-token", cookie.read("token"));
  fheaders.append("exchange-client", "pc");
  if (!options.upload) {
    fheaders.append("Content-Type", "application/json");
  }
  fheaders.append("Accept-Language", window.localStorage.lang);
  if (visitorId) {
    fheaders.append("visitor-id", visitorId);
  }
  if (requestId && options.needRequestId) {
    fheaders.append("request-id", requestId);
  }
  if (options.headers) {
    for (const key in options.headers) {
      if ({}.hasOwnProperty.call(options.headers, key)) {
        fheaders.append(key, options.headers[key]);
      }
    }
  }

  options = Object.assign(
    {
      credentials: options.credentials || "include", // 是否跨域访问cookie， omit默认，same-origin同域，include
      method: options.method || "POST",
      //mode: options.mode || "cors", // 是否允许跨域请求，no-cors默认，same-origin同域，cors跨域
      headers: fheaders,
    },
    options
  );
  if (options.data && !options.body) {
    options.body = options.data;
  }

  if (/get/i.test(options.method)) {
    let str = "";
    const fn = (item, key) => {
      str += `${key}[]=${item}&`;
    };
    for (const key in options.body) {
      if ({}.hasOwnProperty.call(options.body, key)) {
        const v = options.body[key];
        if (Object.prototype.toString.call(v) === "[object Array]") {
          for (let i = 0, l = v.length; i < l; i += 1) {
            fn(v[i], key);
          }
        } else {
          str += `${key}=${options.body[key]}&`;
        }
      }
    }

    str = str.replace(/&$/, "");
    if (str) {
      url += url.indexOf("?") > -1 ? `&${str}` : `?${str}`;
    }
    delete options.body;
  } else {
    options.body = {
      ...options.body,
    };
    options.body = JSON.stringify(options.body);
  }
  // 添加请求超时
  let timeout = 20000; // 默认20秒超时
  let abort = null;
  let timer = null;
  const abortPromise = new Promise((resolve, reject) => {
    abort = () => {
      return reject(new Error(`请求超时: ${url}`));
    };
    // timer = setTimeout(abort, timeout)
  });
  const promise = Promise.race([
    abortPromise,
    fetch(`${url}`, options)
      .then(checkStatus)
      .then((res) => {
        clearTimeout(timer);
        timer = null;
        // 服务端返回的body可能为空
        // http code [ 200 - 300) 返回body为具体数据内容
        // http code <200 || >=300 返回body为报错信息 { code: 415, message, title, ... }
        return res.text().then((d) => {
          if (res.status >= 200 && res.status < 300 && d) {
            let data = {};
            if (d && d.length) {
              data = JSON.parse(d);
            }
            return data;
          } else {
            if (res.status == 403) {
              return {
                code: 403,
                msg: "403 Forbidden",
              };
            }
            let data =
              d && d.length
                ? JSON.parse(d)
                : {
                    code: 1000,
                    msg: "unknown error",
                  };
            return data;
          }
        });
      })
      .catch((err) => {
        return Promise.reject(err);
      }),
  ]);

  Object.defineProperty(promise, "timeout", {
    set: (ts) => {
      if ((ts = +ts)) {
        timeout = ts;
        timer = setTimeout(() => {
          abort();
        }, timeout);
      }
    },
    get: () => {
      return timeout;
    },
  });
  promise.timeout = options.timeout || timeout;

  return promise;
}

export default request;
